'use client';

import type { ComponentProps, ReactNode } from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import { LaunchDarklyFlagsReadyProvider } from 'src/contexts/launch-darkly-flags-ready-context';

type LaunchDarklyFlagsWithStatusProviderProps = Pick<ComponentProps<typeof LDProvider>, 'clientSideID' | 'context'> & {
  readonly children: ReactNode;
};

export function LaunchDarklyFlagsWithStatusProvider({
  children,
  clientSideID,
  context,
}: LaunchDarklyFlagsWithStatusProviderProps) {
  return (
    <LDProvider clientSideID={clientSideID} context={context}>
      <LaunchDarklyFlagsReadyProvider>{children}</LaunchDarklyFlagsReadyProvider>
    </LDProvider>
  );
}
